import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Student+entrepreneur != hard",
  "description": "",
  "published": "2010-03-18T00:00:00.000Z",
  "redirect_from": ["/blog/studententrepreneur-hard/swizec/1254"],
  "categories": "Boxing, Business, Entrepreneur, food for thought, Health, life, People, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Boxing080905_photoshop.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/03/300px-Boxing080905_photoshop.jpg",
              "alt": "Ricardo Dominguez (left) rallied late to win a...",
              "title": "Ricardo Dominguez (left) rallied late to win a..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Boxing080905_photoshop.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Yesterday I gave a guest talk sort of thing at the Jobfair on my faculty. The point was to perform the function of a live demo for my startup incubator and help them get more startups that way.`}</p>
    <p>{`My personal point was to get some blokes to go `}{`_`}{`"HEY! I wanna to help with that too!", `}{`_`}{`which of course did not happen because the audience was mostly electronics and hardware people. But nevertheless, it was a lovely chat.`}</p>
    <p>{`Although, I noticed a very interesting trend. None of them felt very keen on becoming entrepreneurs while still at uni. They thought it was too hard, that next to classes and studying they don't really have time to do anything else. Hell, I even got an almostpplause for being such an impressive lad that I can do both AND keep a girlfriend.`}</p>
    <p>{`But seriously, it's not hard at all. Just take this week's Tuesday as an example:`}</p>
    <blockquote>
      <p parentName="blockquote">{`On Tuesday I worked for nine hours, five of which were studying/taking a hard maths exam (I count school as work because it's my "job"). I went to the playhouse and I watched an episode of `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/House_%28TV_series%29",
          "title": "House (TV series)"
        }}>{`House`}</a>{`. I also helped my girlfriend prepare a presentation for school.`}</p>
      <p parentName="blockquote">{`And I still went to bed by midnight.`}</p>
    </blockquote>
    <p>{`See, it's `}<em parentName="p">{`that`}</em>{` fucking hard!`}</p>
    <p>{`Not only have I never passed as many exams as I have now that I'm also an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Entrepreneur",
        "title": "Entrepreneur"
      }}>{`entrepreneur`}</a>{`, I've also taken up a new sport (boxing), which takes six hours out of every week.`}</p>
    <p>{`Sure it's not all fun and games and many people find it difficult to jam 60 to 70 working hours into every week. But if you think being a student and an entrepreneur is hard, you're trippin' man. Seriously.`}</p>
    <p>{`Just get off yer arse and `}<em parentName="p">{`do`}</em>{` it. The television and alcohol can take care of themselves.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/bd314f7b-c5ee-4679-9dac-34dffbed9ae6/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=bd314f7b-c5ee-4679-9dac-34dffbed9ae6",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      